import React, { useState } from "react";
import style from "./CreditDebit.module.css";
import MenuBar from "./MenuBar";
import BookedDebitNote from "./BookedDebitNote";
import BookedCreditNote from "./BookedCreditNote";
import HeadingBar from "./HeadingBar.js";

const CreditDebit = () => {
  const [activeTab, setActiveTab] = useState("CREDIT");
  const isEmbedded = sessionStorage.getItem("mode") === "embedded";
  return (
    <div className={style.Home}>
      {!isEmbedded && (
        <div className={style.HeadingBarContainer}>
          <HeadingBar />
        </div>
      )}
      <div className={style.HomeContainer}>
        <div className={style.MenuBarContainer}>
          <MenuBar />
        </div>
        <div className={style.MainHomePageContainer}>
          <div className={style.MenuNameDetails}>Credit/Debit Notes</div>

          <div className={style.TabBar}>
            <button
              className={`${style.TabButton} ${
                activeTab === "CREDIT" ? style.ActiveTab : ""
              }`}
              onClick={() => setActiveTab("CREDIT")}
            >
              Credit Notes
            </button>

            <button
              className={`${style.TabButton} ${
                activeTab === "DEBIT" ? style.ActiveTab : ""
              }`}
              onClick={() => setActiveTab("DEBIT")}
            >
              Debit Notes
            </button>
          </div>

          {activeTab === "DEBIT" && <BookedDebitNote />}
          {activeTab === "CREDIT" && <BookedCreditNote />}
        </div>
      </div>
    </div>
  );
};
export default CreditDebit;
